import React from "react";
import Loader from "ae-base/Base/Loader";
import ManagedSection from "../ManagedSection";
import TextItem from "./FileItems/TextItem";
import FileItems from "./FileItems/FileItems";

export default function Managedformsview(props) {
	var model = props.model;
	var forms = model.manage.forms;
	var title = forms.data.title;
	var schema = forms.schema;
	var screen = model.size;

	if(Object.keys(schema).length === 0)
		return <Loader />;


	var renderItems = Object
		.keys(schema.properties)
		.filter(function(name){
			return (typeof forms.data[name] !== "undefined" && name !== "title");
		}).map(function (name) {
			var property = schema.properties[name];
			var value = forms.data[name];

			if(property.type === "string")
				return (
					<TextItem key={name} schema={property} content={value} screen={screen} />
				);

			if(property.format === "file")
				return (
					<FileItems key={name} schema={property} files={value || []} screen={screen} />
				);

			return null;
		});

	var contact = model.manage.account;

	return (
		<ManagedSection model={model} online={model.online} title={title} contact={contact}>
			{renderItems}
		</ManagedSection>
	);
}
